import { withTheme } from 'emotion-theming'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import { withTranslation, Link } from 'server/i18n'
import { useRouter } from 'next/router'

import style from './Categories.style'

const CategoriesStyled = styled.div(props => ({ ...style(props) }))

const Categories = ({ t, categories }) => {
    const router = useRouter()

    return (
        <CategoriesStyled>
            <ul className="categoriesList">
                <li>
                    <Link href="/yacht-news">
                        <a className={router.pathname === '/yacht-news' ? 'active' : ''}>{t('all')}</a>
                    </Link>
                </li>
                {categories.map(cat => (
                    <li key={cat.id}>
                        <Link href={`/yacht-news/${cat.slugEn.slug}`}>
                            <a className={router.query.category === cat.slugEn.slug ? 'active' : ''}>{cat.name}</a>
                        </Link>
                    </li>
                ))}
            </ul>
        </CategoriesStyled>
    )
}

Categories.propTypes = {
    t: PropTypes.func.isRequired,
    categories: PropTypes.array.isRequired
}

export default withTranslation('common')(withTheme(Categories))
